<div class="container container-space">
  @if (profiel$ | async; as profiel) {
    @if (profiel.status === 'ACTIEF' || profiel.status === 'UITGENODIGD') {
      <parkour-profiel-details [profiel]="profiel">
        <p class="text-n-600" data-testid="rol" typeContent>
          {{ uitnodiging.rol | rolLabel }}
        </p>
        @if (profiel.verificatieStatus === 'GEVERIFIEERD') {
          <parkour-profiel-details-geverifieerd-card topCardContent />
        }
      </parkour-profiel-details>
    }
  }
</div>
